export const EDITOR_PARENT_CLASS: string = 'fabric-editor-popup-scroll-parent';
export const EDITOR_CHILDREN_SELECTOR: string = '.ProseMirror > *';
export const RENDERED_CONTENT_SELECTOR: string = '.ak-renderer-document';
export const FABRIC_PAGE_CONTENT_ID: string = 'content';
